import { ContentSection, NewsletterBand, PageHero } from "../components/Sections";
import { ButtonRow, PageSeo } from "../components/PageContent";
import { SmartLink } from "../components/SiteChrome";
import { researchPage } from "../content/pagesContent";
import { sharedContent } from "../content/siteContent";

export default function ResearchPage() {
  return (
    <>
      <PageSeo page={researchPage} />
      <PageHero content={researchPage.hero} />
      <ContentSection className="featured-research">
        <div className="featured-research-heading">
          <p className="eyebrow">{researchPage.featured.heading}</p>
          <h2>{researchPage.featured.title}</h2>
          <div className="research-meta"><strong>{researchPage.featured.author}</strong><span>{researchPage.featured.date}</span></div>
        </div>
        <div className="featured-research-body">
          <div className="long-copy">{researchPage.featured.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}</div>
          <p className="research-status">{researchPage.featured.status}</p>
          <ButtonRow ctas={[{ ...researchPage.featured.primary, style: "primary" }]} />
          <nav className="supporting-links" aria-label="Working paper supporting resources">
            {researchPage.featured.links.map((link) => <SmartLink key={link.label} target={link.target}>{link.label}</SmartLink>)}
          </nav>
        </div>
      </ContentSection>
      <ContentSection className="reference-section" tone="ink" heading="Reference Architectures And Control Patterns">
        <div className="resource-grid">
          {researchPage.resources.map((resource) => (
            <article className="resource-card" key={resource.title}>
              <p className="eyebrow">Reference architecture</p>
              <h3>{resource.title}</h3>
              <SmartLink className="repository-link" target={resource.repoTarget}>{resource.repository}</SmartLink>
              <p>{resource.body}</p>
              <ButtonRow ctas={[{ ...resource.cta, style: "outline" }]} />
            </article>
          ))}
        </div>
      </ContentSection>
      <ContentSection className="research-principles" tone="light">
        <div className="section-heading"><h2>Research Principles</h2></div>
        <p className="section-intro">{researchPage.principles}</p>
      </ContentSection>
      <NewsletterBand content={sharedContent.newsletter} />
    </>
  );
}
